// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2NSfG","label":"CategoryService_label__2NNsa","location":"CategoryService_location__39ctj"};